import React , {useState, useEffect}from 'react';
import ReactDOM from 'react-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BaseDiscountModel = ({ isShowing, hide , rates ,Rangefrom, Rangeto, updateRate}) => {
  console.log('Rate', rates);
const [discount, handlediscount] = useState(0);
const [count, handleCount] = useState(1);
const [disable, handleDisable] =useState("disableButton");
  useEffect(() => {
    if (count === 1) {
        handlediscount(rates.discount ? rates.discount : 0)
    }
  })
  const getDiscount = e => {
    if(Number(e.target.value)<=100 && e.target.value.length >0 && e.target.value[0]!= "-" && ((Number(e.target.value)<10 && e.target.value.length <=4) ||Number(e.target.value)>=10 && e.target.value.length <=5)){
      handlediscount(Number(e.target.value))
    }
    else if(e.target.value === ""){
      handlediscount("")
    }
  
    handleCount(count + 1);
    handleDisable('');
  }
  const closePopup = () => {
    hide();
    handleCount(1);
  }

  const updateRates = (e) =>{
    e.preventDefault();
   
     if((Rangefrom || Rangeto) && rates.type === "Rangeto" && Number(discount) >= Rangefrom  && !toast.isActive("1")){
      toast.error(`discount must be smaller than ${Rangefrom}`, {
        position:toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar:true,
        toastId:"1"
     });
     return
    }
    else if((Rangefrom || Rangeto) && rates.type === "Rangefrom" && Number(discount) <= Rangeto  && !toast.isActive("2")){
      toast.error(`discount must be greater than ${Rangeto}`, {
        position:toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar:true,
        toastId:"2"
     });
     return
    }
    else if(toast.isActive("1") || toast.isActive("2") || toast.isActive("3")){
      return
    }
    if(discount ===""){
      toast.error('Please enter valid number', {
        position:toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar:true,
        toastId:"3"
     });
     return
    }
   
   
    handleCount(1);
    const params ={
      _id :rates._id,
      discount: Number(discount)
     }
     updateRate(params)
  }

return(
  isShowing?  <div>
  <div className="modal-overlay">
    <div className="modal-wrapper thankyou-popup" aria-modal aria-hidden tabIndex={-1} role="dialog">
      <div className="modal">
        <div className="modal-head-cross rate-modal">
          <button type="button" className="modal-close-button" onClick={closePopup}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
       
        <div className="editNonFct-header modal-header" >
          <h4 className="popup-head rqst-head fct-head modal-title">Manage Base Discount</h4></div>
        <div className="editNonFct-modal modal-body">
          <div className="bg-white">
            <form className="form-group">
              <div className="popupCampaign-container">
               
               
                {/* <div className="campaign-input master-inputs nonFct">
                  <div className="input-tag signup-tag clearfix fct-input">
                    <label className="static-value">Type</label>
                    <input name="stationName" type="text" className="form-control" value ={rates.type} readOnly />
                  </div>
                </div> */}


                <div className="campaign-input master-inputs nonFct">
                <div className="input-tag signup-tag clearfix fct-input">
                    <label className="static-value">Range From</label>
                    <input name="stationName" type="text" className="form-control" value ={rates.totalSecondagesFrom} readOnly />
                  </div>
                  </div>

                  <div className="campaign-input master-inputs nonFct">
                  <div className="input-tag signup-tag clearfix fct-input">
                    <label className="static-value">Range To</label>
                    <input name="stationName" type="text" className="form-control" value ={rates.totalSecondagesTo} readOnly />
                  </div>
                  </div>

                <div className="campaign-input master-inputs nonFct">
                  <div className="input-tag signup-tag clearfix fct-input">
                    <label className="static-value">Discount</label>
                    <input name="stockUpdate" type="number" className="form-control"  value ={discount} onChange={getDiscount}/>
                  </div>
                </div>
                <div className="create-camp nonfct-submit">
                  <button className={disable} onClick={updateRates}>SAVE CHANGES</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
        </div>
        {/* <div className="modal-footer cost_button">
         <button className="cncl">Cancel</button>
         <button className="procd">Ok</button>
        </div> */}
      </div>
    </div>
    <ToastContainer />
</div>:null
)
}

export default BaseDiscountModel;


// WEBPACK FOOTER //
// ./web/components/admin/common/baseDiscountModel.js